<template>
  <svg fill="none" viewBox="0 0 125 125">
    <mask
      id="common-qr-kz-a"
      width="121"
      height="121"
      x="2"
      y="2"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path fill="#fff" d="M43.947 2.718h-4.123V6.84h4.123V2.718Z" />
      <path fill="#fff" d="M56.318 2.718h-4.123V6.84h4.123V2.718Z" />
      <path fill="#fff" d="M60.44 2.718h-4.124V6.84h4.123V2.718Z" />
      <path fill="#fff" d="M68.685 2.718h-4.123V6.84h4.123V2.718Z" />
      <path fill="#fff" d="M72.808 2.718h-4.123V6.84h4.123V2.718Z" />
      <path fill="#fff" d="M76.931 2.718H72.81V6.84h4.123V2.718Z" />
      <path fill="#fff" d="M52.195 6.84h-4.123v4.124h4.123V6.84Z" />
      <path fill="#fff" d="M68.685 6.84h-4.123v4.124h4.123V6.84Z" />
      <path fill="#fff" d="M72.808 6.84h-4.123v4.124h4.123V6.84Z" />
      <path fill="#fff" d="M85.178 6.84h-4.123v4.124h4.123V6.84Z" />
      <path fill="#fff" d="M89.3 6.84h-4.122v4.124H89.3V6.84Z" />
      <path fill="#fff" d="M39.826 10.963h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 10.963h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M60.44 10.963h-4.124v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 10.963h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M72.808 10.963h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 10.963H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 15.086h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 15.086h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 15.086h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M72.808 15.086h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 15.086h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 19.21h-4.123v4.122h4.123V19.21Z" />
      <path fill="#fff" d="M43.947 19.21h-4.123v4.122h4.123V19.21Z" />
      <path fill="#fff" d="M48.07 19.21h-4.123v4.122h4.123V19.21Z" />
      <path fill="#fff" d="M52.195 19.21h-4.123v4.122h4.123V19.21Z" />
      <path fill="#fff" d="M56.318 19.21h-4.123v4.122h4.123V19.21Z" />
      <path fill="#fff" d="M81.055 19.21h-4.123v4.122h4.123V19.21Z" />
      <path fill="#fff" d="M39.826 23.332h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 23.332h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 23.332h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 23.332h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 23.332H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 23.332h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 23.332h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 27.455h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 27.455h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 27.455h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 27.455H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M72.808 27.455h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 27.455h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 27.455h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M43.947 31.578h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 31.578h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 31.578H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M76.931 31.578H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 31.578h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 31.578h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M10.965 35.701H6.842v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M23.334 35.701H19.21v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M31.58 35.701h-4.123v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M39.826 35.701h-4.123v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M43.947 35.701h-4.123v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M56.318 35.701h-4.123v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M60.44 35.701h-4.124v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M64.562 35.701H60.44v4.123h4.122V35.7Z" />
      <path fill="#fff" d="M76.931 35.701H72.81v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M93.424 35.701H89.3v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M101.67 35.701h-4.123v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M105.793 35.701h-4.123v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M114.039 35.701h-4.123v4.123h4.123V35.7Z" />
      <path fill="#fff" d="M6.842 39.824H2.719v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M15.088 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M19.21 39.824h-4.122v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M27.457 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 39.824H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M68.685 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M97.547 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M101.67 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 39.824h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M15.088 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M27.457 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M31.58 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M60.44 43.947h-4.124v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 43.947H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M72.808 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 43.947H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 43.947h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M93.424 43.947H89.3v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M114.039 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 43.947h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M6.842 48.07H2.719v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M10.965 48.07H6.842v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M23.334 48.07H19.21v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M35.703 48.07H31.58v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M43.947 48.07h-4.123v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M52.195 48.07h-4.123v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M56.318 48.07h-4.123v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M60.44 48.07h-4.124v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M76.931 48.07H72.81v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M85.178 48.07h-4.123v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M89.3 48.07h-4.122v4.123H89.3V48.07Z" />
      <path fill="#fff" d="M93.424 48.07H89.3v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M109.914 48.07h-4.123v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M118.162 48.07h-4.123v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M122.285 48.07h-4.123v4.123h4.123V48.07Z" />
      <path fill="#fff" d="M6.842 52.193H2.719v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M10.965 52.193H6.842v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M15.088 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M27.457 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M31.58 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M35.703 52.193H31.58v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 52.193H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 52.193h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M101.67 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M109.914 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 52.193h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M15.088 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M23.334 56.316H19.21v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M35.703 56.316H31.58v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M72.808 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 56.316H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M97.547 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M114.039 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 56.316h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M6.842 60.439H2.719v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M15.088 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M23.334 60.439H19.21v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M27.457 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M31.58 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M35.703 60.439H31.58v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M60.44 60.439h-4.124v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 60.439H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 60.439h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M93.424 60.439H89.3v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M97.547 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 60.439h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M6.842 64.562H2.719v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M19.21 64.562h-4.122v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M23.334 64.562H19.21v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M27.457 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 64.562H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M76.931 64.562H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 64.562h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M97.547 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M101.67 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M109.914 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 64.562h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M6.842 68.685H2.719v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M15.088 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M23.334 68.685H19.21v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M31.58 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M60.44 68.685h-4.124v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 68.685H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M68.685 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 68.685H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 68.685h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M93.424 68.685H89.3v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 68.685h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M6.842 72.807H2.719v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M10.965 72.807H6.842v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M15.088 72.807h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M19.21 72.807h-4.122v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M23.334 72.807H19.21v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M60.44 72.807h-4.124v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 72.807H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M72.808 72.807h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 72.807h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M97.547 72.807h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M101.67 72.807h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 72.807h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M109.914 72.807h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 72.807h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M23.334 76.93H19.21v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M27.457 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M31.58 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M39.826 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M43.947 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M56.318 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M60.44 76.93h-4.124v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M72.808 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M76.931 76.93H72.81v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M89.3 76.93h-4.122v4.123H89.3V76.93Z" />
      <path fill="#fff" d="M105.793 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M109.914 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M114.039 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M122.285 76.93h-4.123v4.123h4.123V76.93Z" />
      <path fill="#fff" d="M19.21 81.053h-4.122v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M27.457 81.053h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M35.703 81.053H31.58v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 81.053h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 81.053h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 81.053H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 81.053h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 81.053h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M105.793 81.053h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M109.914 81.053h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M6.842 85.176H2.719V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M10.965 85.176H6.842V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M19.21 85.176h-4.122V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M23.334 85.176H19.21V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M31.58 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M35.703 85.176H31.58V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 85.176H72.81V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 85.176h-4.122V89.3H89.3v-4.123Z" />
      <path fill="#fff" d="M93.424 85.176H89.3V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M97.547 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M101.67 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 85.176h-4.123V89.3h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M43.947 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M56.318 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M60.44 89.3h-4.124v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M64.562 89.3H60.44v4.122h4.122V89.3Z" />
      <path fill="#fff" d="M68.685 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M72.808 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M76.931 89.3H72.81v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M85.178 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M89.3 89.3h-4.122v4.122H89.3V89.3Z" />
      <path fill="#fff" d="M105.793 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M114.039 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M122.285 89.3h-4.123v4.122h4.123V89.3Z" />
      <path fill="#fff" d="M43.947 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M72.808 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 93.422h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M97.547 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 93.422h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M72.808 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 97.545H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 97.545h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M105.793 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M109.914 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 97.545h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M60.44 101.668h-4.124v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 101.668H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M76.931 101.668H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 101.668h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M93.424 101.668H89.3v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M97.547 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M101.67 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 101.668h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 105.791h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M81.055 105.791h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M101.67 105.791h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M109.914 105.791h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 105.791h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M48.07 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 109.914H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M85.178 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 109.914h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M93.424 109.914H89.3v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M114.039 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 109.914h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M39.826 114.037h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 114.037h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M60.44 114.037h-4.124v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M68.685 114.037h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 114.037H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 114.037h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M101.67 114.037h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 114.037h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M122.285 114.037h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M43.947 118.16h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M52.195 118.16h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M56.318 118.16h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M64.562 118.16H60.44v4.123h4.122v-4.123Z" />
      <path fill="#fff" d="M72.808 118.16h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M76.931 118.16H72.81v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M89.3 118.16h-4.122v4.123H89.3v-4.123Z" />
      <path fill="#fff" d="M93.424 118.16H89.3v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M105.793 118.16h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M109.914 118.16h-4.123v4.123h4.123v-4.123Z" />
      <path fill="#fff" d="M118.162 118.16h-4.123v4.123h4.123v-4.123Z" />
    </mask>
    <g mask="url(#common-qr-kz-a)">
      <path fill="#000" d="M125 0H0v125h125V0Z" />
    </g>
    <mask
      id="common-qr-kz-b"
      width="30"
      height="30"
      x="2"
      y="2"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M2.719 2.718v28.86h28.86V2.718H2.72ZM6.842 6.84h20.614v20.614H6.842V6.841Z"
        clip-rule="evenodd"
      />
    </mask>
    <g mask="url(#common-qr-kz-b)">
      <path fill="#000" d="M31.58 2.717H2.718v28.861h28.86V2.718Z" />
    </g>
    <mask
      id="common-qr-kz-c"
      width="14"
      height="14"
      x="10"
      y="10"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path fill="#fff" d="M23.332 10.963h-12.37v12.369h12.37V10.963Z" />
    </mask>
    <g mask="url(#common-qr-kz-c)">
      <path fill="#000" d="M23.332 10.963h-12.37v12.369h12.37V10.963Z" />
    </g>
    <mask
      id="common-qr-kz-d"
      width="30"
      height="30"
      x="93"
      y="2"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M122.283 2.717h-28.86v28.861h28.86V2.718ZM118.16 6.84v20.615H97.546V6.84h20.614Z"
        clip-rule="evenodd"
      />
    </mask>
    <g mask="url(#common-qr-kz-d)">
      <path fill="#000" d="M122.282 2.717h-28.86v28.86h28.86V2.718Z" />
    </g>
    <mask
      id="common-qr-kz-e"
      width="14"
      height="14"
      x="101"
      y="10"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path fill="#fff" d="M114.035 23.332v-12.37h-12.369v12.37h12.369Z" />
    </mask>
    <g mask="url(#common-qr-kz-e)">
      <path fill="#000" d="M114.037 10.963h-12.369v12.369h12.369V10.963Z" />
    </g>
    <mask
      id="common-qr-kz-f"
      width="30"
      height="30"
      x="2"
      y="93"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M2.719 122.283h28.86v-28.86H2.72v28.86Zm4.123-4.123V97.545h20.614v20.615H6.842Z"
        clip-rule="evenodd"
      />
    </mask>
    <g mask="url(#common-qr-kz-f)">
      <path fill="#000" d="M31.58 93.422H2.718v28.861h28.86v-28.86Z" />
    </g>
    <mask
      id="common-qr-kz-g"
      width="14"
      height="14"
      x="10"
      y="101"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path fill="#fff" d="M10.963 101.668v12.369h12.369v-12.369h-12.37Z" />
    </mask>
    <g mask="url(#common-qr-kz-g)">
      <path fill="#000" d="M23.332 101.668h-12.37v12.369h12.37v-12.369Z" />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'ga-icon-common-qr-kz',
}
</script>
